export default {
  SET_USER_DATA: 'SET_USER_DATA',
  LOGOUT: 'LOGOUT',
};
